<template>
    <el-form :inline="true" @submit.prevent.native="$emit('submit')">
        <el-form-item class="list__search-wrapper">
            <el-input class="list__search"
                      :value="value"
                      @input="onInput"
                      :placeholder="$t('query')"/>
        </el-form-item>
        <el-form-item class="list__search-wrapper">
            <el-button @click="$emit('submit')">{{ $t('search') }}</el-button>
        </el-form-item>
    </el-form>

</template>
<script>
    import debounce from 'lodash.debounce'

    export default {
        props: ["value"],
        created () {
            this.submitSearch = debounce(() => {
                this.$emit('submit')
            }, 300);
        },
        methods: {
            onInput (value) {
                this.$emit('input', value)
                this.submitSearch()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// SearchListForm.vue?407cf602